(function () {
  if (window.pdTactile) return;
  window.pdTactile = true;
  var tactile = window.matchMedia('(hover: none)').matches;
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!tactile || reduit) return;

  function borne(v, a, b) { return Math.max(a, Math.min(b, v)); }
  // Valeurs partagées avec la scène 3D : x, y = inclinaison du téléphone (-1 à 1), yaw = rotation au doigt (radians)
  var M = window.pdMouvement = { x: 0, y: 0, yaw: 0, actif: false };

  /* ---------- Gyroscope ---------- */
  var base = null, cx = 0, cy = 0, tx = 0, ty = 0, prevu = false;
  function surOrientation(e) {
    if (e.gamma === null || e.beta === null) return;
    if (base === null) base = e.beta; // position de tenue de départ
    tx = borne(e.gamma / 25, -1, 1);
    ty = borne((e.beta - base) / 25, -1, 1);
    if (!M.actif) { M.actif = true; document.documentElement.classList.add('pd-gyro'); masquerBouton(); }
    if (!prevu) { prevu = true; requestAnimationFrame(applique); }
  }
  function applique() {
    prevu = false;
    cx += (tx - cx) * .2; cy += (ty - cy) * .2;
    M.x = cx; M.y = cy;
    var objet = document.querySelector('.pd-fiche[open] .pd-fiche__objet:not(.is-drag)');
    if (objet) objet.style.setProperty('--angle', (cx * 35) + 'deg');
    defile();
    if (Math.abs(tx - cx) > .002 || Math.abs(ty - cy) > .002) { prevu = true; requestAnimationFrame(applique); }
  }

  /* ---------- Effets pilotés par le défilement ---------- */
  // Chaque article s'incline selon sa position à l'écran : penché en bas, droit et plus grand au centre, basculé en haut
  function defile() {
    var H = window.innerHeight;
    document.querySelectorAll('.pd-cat__carte:not([hidden])').forEach(function (carte, i) {
      var tilt = carte.querySelector('.pd-tilt');
      if (!tilt || tilt.dataset.doigt) return;
      var r = carte.getBoundingClientRect();
      if (r.bottom < -50 || r.top > H + 50) return;
      var c = borne(((r.top + r.height / 2) - H / 2) / (H / 2), -1, 1); // -1 en haut, 0 au centre, 1 en bas
      var cote = (r.left + r.width / 2) < window.innerWidth / 2 ? -1 : 1;
      var focus = 1 - Math.min(1, Math.abs(c));
      tilt.style.setProperty('--rx', (c * 22 - cy * 12) + 'deg');
      tilt.style.setProperty('--ry', (cote * c * 14 + cx * 16) + 'deg');
      tilt.style.setProperty('--sc', (.93 + .07 * focus).toFixed(3));
      tilt.style.setProperty('--gx', ((cx + 1) * 50 - cote * c * 20) + '%');
      tilt.style.setProperty('--gy', ((c + 1) * 50) + '%');
      carte.style.setProperty('--focus', focus.toFixed(3));
    });
  }
  var defilePrevu = false;
  window.addEventListener('scroll', function () {
    if (defilePrevu) return; defilePrevu = true;
    requestAnimationFrame(function () { defilePrevu = false; defile(); });
  }, { passive: true });
  window.addEventListener('resize', defile);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-filtre]')) setTimeout(defile, 60); });
  function demarreDefile() { document.documentElement.classList.add('pd-defile'); defile(); reveler(); }

  // Apparition en glissant quand les éléments entrent à l'écran
  function reveler() {
    if (!('IntersectionObserver' in window)) return;
    var cibles = document.querySelectorAll('.pd-cat__carte, .pd-q, .pd-resultat, .pd-contact__carte, .pd-contact__formulaire, .pd-finder h2, .pd-cat h2, .pd-bandeau__contenu > *');
    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-vu'); obs.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    cibles.forEach(function (el, i) {
      if (el.getBoundingClientRect().top < window.innerHeight * .9) { el.classList.add('is-vu'); return; }
      el.classList.add('pd-revele');
      el.style.transitionDelay = ((el.classList.contains('pd-cat__carte') ? (i % 2) * 90 : 0)) + 'ms';
      obs.observe(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarreDefile); else demarreDefile();
  document.addEventListener('shopify:section:load', demarreDefile);

  function ecouter() { window.addEventListener('deviceorientation', surOrientation); }

  // iPhone : l'accès au gyroscope demande un appui de l'utilisateur
  var bouton = null;
  function masquerBouton() { if (bouton) { bouton.remove(); bouton = null; } }
  if (window.DeviceOrientationEvent && typeof DeviceOrientationEvent.requestPermission === 'function') {
    if (!sessionStorageSafe('pd-gyro-refus')) {
      bouton = document.createElement('button');
      bouton.type = 'button';
      bouton.className = 'pd-gyro-bouton';
      bouton.textContent = 'Activer l\u2019effet 3D';
      bouton.addEventListener('click', function () {
        DeviceOrientationEvent.requestPermission().then(function (r) {
          if (r === 'granted') ecouter(); else { try { sessionStorage.setItem('pd-gyro-refus', '1'); } catch (e) {} }
          masquerBouton();
        }).catch(masquerBouton);
      });
      var ajoute = function () { if (bouton && document.querySelector('.pd-cat, .pdX')) document.body.appendChild(bouton); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ajoute); else ajoute();
    }
  } else {
    ecouter();
  }
  function sessionStorageSafe(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }

  /* ---------- Glisser le doigt sur un article ---------- */
  var suivi = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'touch') return;
    var visuel = e.target.closest && e.target.closest('.pd-cat__visuel');
    if (!visuel) return;
    suivi = { el: visuel, tilt: visuel.querySelector('.pd-tilt'), x0: e.clientX, y0: e.clientY, bouge: false };
  }, { passive: true });
  document.addEventListener('pointermove', function (e) {
    if (!suivi || e.pointerType !== 'touch') return;
    var dx = e.clientX - suivi.x0, dy = e.clientY - suivi.y0;
    if (Math.abs(dx) > 6) suivi.bouge = true;
    var r = suivi.el.getBoundingClientRect();
    var nx = borne((e.clientX - r.left) / r.width - .5, -.5, .5), ny = borne((e.clientY - r.top) / r.height - .5, -.5, .5);
    suivi.tilt.dataset.doigt = '1';
    suivi.tilt.style.setProperty('--rx', (-ny * 22) + 'deg');
    suivi.tilt.style.setProperty('--ry', (nx * 30) + 'deg');
    suivi.tilt.style.setProperty('--gx', ((nx + .5) * 100) + '%');
    suivi.tilt.style.setProperty('--gy', ((ny + .5) * 100) + '%');
    suivi.el.classList.add('is-touche');
  }, { passive: true });
  function relache() {
    if (!suivi) return;
    var s = suivi; suivi = null;
    delete s.tilt.dataset.doigt;
    s.el.classList.remove('is-touche');
    defile();
    if (s.bouge) { // un glissement ne doit pas ouvrir la fiche
      var bloque = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
      s.el.addEventListener('click', bloque, { capture: true, once: true });
      setTimeout(function () { s.el.removeEventListener('click', bloque, { capture: true }); }, 400);
    }
  }
  document.addEventListener('pointerup', relache, { passive: true });
  document.addEventListener('pointercancel', relache, { passive: true });

  /* ---------- Glisser horizontalement dans la scène 3D ---------- */
  var orbite = null, ressort = false;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'touch') return;
    var sc = e.target.closest && e.target.closest('.pdX-collant');
    if (!sc || e.target.closest('a, button')) return;
    orbite = { x0: e.clientX, yaw0: M.yaw, w: sc.offsetWidth };
  }, { passive: true });
  document.addEventListener('pointermove', function (e) {
    if (!orbite || e.pointerType !== 'touch') return;
    M.yaw = borne(orbite.yaw0 + (e.clientX - orbite.x0) / orbite.w * 1.4, -.6, .6);
  }, { passive: true });
  function finOrbite() {
    if (!orbite) return; orbite = null;
    if (ressort) return; ressort = true;
    (function retour() { // revient doucement en place
      M.yaw *= .9;
      if (Math.abs(M.yaw) > .002 && !orbite) requestAnimationFrame(retour); else { if (!orbite) M.yaw = 0; ressort = false; }
    })();
  }
  document.addEventListener('pointerup', finOrbite, { passive: true });
  document.addEventListener('pointercancel', finOrbite, { passive: true });

  /* ---------- Vibration légère (Android) ---------- */
  document.addEventListener('click', function (e) {
    if (!navigator.vibrate) return;
    if (e.target.closest && e.target.closest('.pd-swatch, [data-filtre], .pd-vue, .pd-q__choix label, .pd-onglets button')) navigator.vibrate(8);
  }, true);
})();
